export default __webpack_public_path__ + "static/media/accuracy.60f42fe0.svg";